import React from "react";
import styled from "styled-components";

import { Flex, Txt } from "../../../../hex-components";
import { maybePluralize } from "../../../../util/string";
import { CellTypeIcon } from "../../../cell/CellTypeIcon";
import { Heading } from "../../../Heading";

import { getUsageCellLabel } from "./getUsageCellLabel";
import { UsageCellLink } from "./UsagesCellLink";
import { WithUsagesData } from "./useUsagesCells";

type UsagesPopoverContentProps = WithUsagesData;

export const UsagesPopoverContent = React.memo<UsagesPopoverContentProps>(
  function UsagesPopoverContent({ cells }) {
    return (
      <Flex align="stretch" direction="column" gap={6}>
        <Heading renderAs="h3" styleAs="h5">
          {cells.length} {maybePluralize(cells.length, "Cell", "Cells")}
        </Heading>
        <CellListFlex direction="column" gap={6}>
          {cells.map((cell) => (
            <Flex key={cell.id} css="max-width: 100%;" gap={4}>
              <CellTypeIcon cellType={cell.cellType} />
              <Txt ellipsize={true} fontColor="muted" fontSize="small">
                <UsageCellLink cell={cell}>
                  {getUsageCellLabel({ cell })}
                </UsageCellLink>
              </Txt>
            </Flex>
          ))}
        </CellListFlex>
        {cells.some((cell) => cell.onlyExistsInPublished) && (
          <Txt css="margin-top: 6px;" fontColor="muted" fontSize="extra_small">
            * Only exists in published version
          </Txt>
        )}
      </Flex>
    );
  },
);

const CellListFlex = styled(Flex)`
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
`;
